/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


/* eslint-enable no-console */


const swiperDondePagar = new Swiper(".sc-donde-pagar__container__left__mobile", {
    rewind: true,
    speed: 500,
    navigation: {
        nextEl: ".sc-donde-pagar__container__left__mobile__buttons__next-button",
        prevEl: ".sc-donde-pagar__container__left__mobile__buttons__prev-button",
    },
});

import anime from "animejs/lib/anime.es.js";

const cards = document.querySelectorAll(".sc-donde-pagar__container__left__mobile__card");

const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.0,
};

function handleCardEntry(entries, observer) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            animateCard(entry.target);
            observer.unobserve(entry.target);
        }
    });
}

const initCardObserver = () => {
    const observer = new IntersectionObserver(handleCardEntry, observerOptions);
    cards.forEach((card) => observer.observe(card));
};

const animateCard = (card) => {
    const style = window.getComputedStyle(card);
    const leftValue = style.getPropertyValue("left");

    if (leftValue.charAt(0) === "-") {
        anime({
            targets: card,
            right: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 500,
            delay: 500,
        });
    } else {
        anime({
            targets: card,
            left: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 500,
            delay: 500,
        });
    }
};
initCardObserver();
